
import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'

import VueI18n from 'vue-i18n'
import $Cookies from 'js-cookie';
Vue.use(VueI18n)
// Vue.locale('en_US', enLocale);

import store from '@/common/store/'

import { getQueryFromHrefByName } from '@/common/utils/index.js'

// 多语言相关数据
var langs = {
  keys: '',
  langsOptions: {},
  database: null
}
var langArray = ['en_US', 'hi_IN'] // 设置需要显示的语言
// var langArray = ['en_US', 'hi_IN', 'zh_CN'] // 设置需要显示的语言

const langsFiles = require.context('./langs', true, /\.js$/)
const messages = langsFiles.keys().reduce((lan, langsPath) => {
  const langsName = langsPath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = langsFiles(langsPath)
  if (langArray.includes(langsName)) {
    let obj = {}
    langArray.forEach((item) => {
      obj[item] = value.default['langsOptions'][item]
    })
    langs.langsOptions[langsName] = obj
    // lan[langsName] = value.default
    lan[langsName] = Object.assign(value.default, enLocale)
  }
  return lan
}, {})

var keysVal = langArray[0]
if ($Cookies.get('lang') && langArray.includes($Cookies.get('lang'))) keysVal = $Cookies.get('lang')
if (getQueryFromHrefByName('lang')) keysVal = getQueryFromHrefByName('lang')
langs.keys = keysVal
$Cookies.set('lang', langs.keys)
langs.database = messages
store.commit('setlangs', langs)

const i18n = new VueI18n({
  locale: langs.keys,
  messages,
  silentTranslationWarn: true // 去除警告
})

locale.i18n((key, value) => i18n.t(key, value)) //重点：为了实现element插件的多语言切换
export default i18n



// WEBPACK FOOTER //
// ./src/pages/build922/i18n/i18n.js